import { BaseConnectedMouse } from '../../types/base'
import { FeatureBase } from '../FeatureBase'

declare module '../FeatureMap' {
  export interface DeviceFeatureMap {
    /** 底座设置能力：固件版本、频段、子鼠标识别。 */
    baseSettings: IBaseSettingsFeature
  }
}

export interface IBaseSettingsFeature {
  /** 读取底座固件版本。不同协议会组装成不同段数的版本字符串。 */
  getFirmwareVersion(): Promise<string>
  /** 读取 2.4G 频段索引，范围通常为 0-7。 */
  getChannelIndex(): Promise<number>
  /** 设置 2.4G 频段索引，范围 0-7。 */
  setChannelIndex(index: number): Promise<void>
  /** 同时读取底座当前配对子鼠标的 VID/PID。 */
  getConnectedMouse(): Promise<BaseConnectedMouse>
  /** 读取底座当前配对子鼠标的 VID。 */
  getConnectedMouseVendorId(): Promise<number | undefined>
  /** 读取底座当前配对子鼠标的 PID。 */
  getConnectedMouseProductId(): Promise<number | undefined>
}

/** 底座设置 feature 抽象类，具体实现位于 chips/shared/feature-impls/base-settings。 */
export class BaseSettingsFeature extends FeatureBase implements IBaseSettingsFeature {
  getFirmwareVersion(): Promise<string> {
    return this.unsupported('BaseSettingsFeature.getFirmwareVersion')
  }
  getChannelIndex(): Promise<number> {
    return this.unsupported('BaseSettingsFeature.getChannelIndex')
  }
  setChannelIndex(_index: number): Promise<void> {
    return this.unsupported('BaseSettingsFeature.setChannelIndex')
  }
  getConnectedMouse(): Promise<BaseConnectedMouse> {
    return this.unsupported('BaseSettingsFeature.getConnectedMouse')
  }
  getConnectedMouseVendorId(): Promise<number | undefined> {
    return this.unsupported('BaseSettingsFeature.getConnectedMouseVendorId')
  }
  getConnectedMouseProductId(): Promise<number | undefined> {
    return this.unsupported('BaseSettingsFeature.getConnectedMouseProductId')
  }
}
